/*
  Raaga collection behaviour (raaga/collection.html → seedFilters/render).

  Without this file the page still works: the facets are a GET form, the price
  bands and the chips are links, and Load more is the next page. With it, every
  one of those swaps the grid and the facet counts in place, the way the
  mockup's render() did, and the URL keeps up.
*/
(function () {
  var BUSY = 'is-busy';

  function root() { return document.querySelector('[data-rgc]'); }

  /* ── the drawer, same motion as the header's menu ───────────── */
  function drawer(scope) {
    var box = scope.querySelector('.rgc-scrim');
    var open = scope.querySelector('[data-rgc-open]');
    if (!box || !open || box.dataset.rgcBound) return;
    box.dataset.rgcBound = 'true';

    function onKey(e) { if (e.key === 'Escape') close(); }
    function show() {
      box.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      requestAnimationFrame(function () {
        box.classList.add('on');
        var c = box.querySelector('[data-rgc-close]');
        if (c) setTimeout(function () { c.focus(); }, 60);
      });
    }
    function close() {
      if (!box.classList.contains('on')) return;
      box.classList.remove('on');
      open.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      open.focus();
      setTimeout(function () { if (!box.classList.contains('on')) box.hidden = true; }, 340);
    }
    open.addEventListener('click', show);
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.closest('[data-rgc-close]')) close();
    });
  }

  /* ── the filter bar's dropdowns, one open at a time ─────────── */
  function openDd(scope) { return scope.querySelector('[data-rgc-dd][aria-expanded="true"]'); }

  function closeDd(scope, refocus) {
    var btn = openDd(scope);
    if (!btn) return;
    btn.setAttribute('aria-expanded', 'false');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
    if (refocus) btn.focus();
  }

  function showDd(scope, btn) {
    closeDd(scope);
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var bar = btn.closest('.rgc-bar');
    if (!panel || !bar) return;
    btn.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    /* under the pill, kept inside the bar so it never runs off a phone screen */
    var b = bar.getBoundingClientRect();
    var x = btn.getBoundingClientRect().left - b.left;
    x = Math.max(0, Math.min(x, b.width - panel.offsetWidth));
    panel.style.setProperty('--rgc-dd-x', x + 'px');
  }

  function dropdowns(scope) {
    if (scope.dataset.rgcDd) return;
    scope.dataset.rgcDd = 'true';

    scope.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rgc-dd]');
      if (!btn) return;
      if (btn.getAttribute('aria-expanded') === 'true') closeDd(scope);
      else showDd(scope, btn);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.rgc-dd')) closeDd(scope);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openDd(scope)) closeDd(scope, true);
    });
    /* the panel is pinned to where the pill was, so a scroll of the row closes it */
    var row = scope.querySelector('.rgc-bar__row');
    if (row) row.addEventListener('scroll', function () { closeDd(scope); }, { passive: true });
    window.addEventListener('resize', function () { closeDd(scope); });
  }

  /* ── fetch a filtered URL and swap what changed ─────────────── */
  function swap(url, push) {
    var scope = root();
    if (!scope) return;
    var results = scope.querySelector('[data-rgc-results]');
    if (results) results.classList.add(BUSY);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rgc]');
        if (!next) throw new Error('no section in response');

        /* keep the dropdown the shopper is working in open, and their place in it */
        var was = openDd(scope);
        var key = was && was.getAttribute('aria-controls');
        var f = document.activeElement;
        var focusSel = f && f.name && f.closest('.rgc-dd__panel')
          ? 'input[name="' + CSS.escape(f.name) + '"][value="' + CSS.escape(f.value) + '"]'
          : null;

        [
          '[data-rgc-results]',
          '[data-rgc-facets]',
          '[data-rgc-chips]',
          '[data-rgc-sortbox]',
          '[data-rgc-crumb]',
          '[data-rgc-fn]'
        ].forEach(function (sel) {
          var a = scope.querySelector(sel), b = next.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });

        var ct = next.querySelector('[data-rgc-count]');
        if (ct) {
          scope.querySelectorAll('[data-rgc-count]').forEach(function (e) { e.textContent = ct.textContent; });
        }
        var mc = next.querySelector('[data-rgc-mcount]');
        var mine = scope.querySelector('[data-rgc-mcount]');
        if (mc && mine) mine.textContent = mc.textContent;

        if (key) {
          var again = scope.querySelector('[data-rgc-dd][aria-controls="' + key + '"]');
          if (again) showDd(scope, again);
          var back = focusSel && scope.querySelector(focusSel);
          if (back) back.focus();
        }

        if (push !== false) history.pushState({ rgc: true }, '', url);
        wake(scope);
        if (results) results.classList.remove(BUSY);
      })
      .catch(function () {
        /* the network is the wrong place to be clever — just navigate */
        window.location.href = url;
      });
  }

  /* raaga-home.js binds trays, size buttons and the reveal on this event */
  function wake(scope) {
    scope.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  }

  /* ── load more, appended rather than paged ──────────────────── */
  function more(e, link) {
    e.preventDefault();
    var scope = root();
    var box = link.closest('[data-rgc-more]');
    link.setAttribute('aria-busy', 'true');

    fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rgc]');
        var grid = scope.querySelector('[data-rgc-grid]');
        var add = next && next.querySelector('[data-rgc-grid]');
        if (!grid || !add) throw new Error('no grid in response');

        while (add.firstElementChild) grid.appendChild(add.firstElementChild);

        var nb = next.querySelector('[data-rgc-more]');
        if (nb && box) box.replaceWith(nb);
        else if (box) box.remove();

        history.replaceState({ rgc: true }, '', link.href);
        wake(scope);
      })
      .catch(function () { window.location.href = link.href; });
  }

  /* ── wiring ─────────────────────────────────────────────────── */
  function bind(scope) {
    if (!scope || scope.dataset.rgcWired) return;
    scope.dataset.rgcWired = 'true';
    var form = scope.querySelector('[data-rgc-form]');
    if (!form) return;

    /* a facet change is a form submit, intercepted */
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="checkbox"], input[type="radio"], select')) return;
      /* a sort is one choice, so its panel is done once it is made */
      if (e.target.type === 'radio') closeDd(scope);
      /* the size pills paint from a class, so answer the press before the fetch lands */
      var pill = e.target.closest('.rgc-pill');
      if (pill) pill.classList.toggle('is-on', e.target.checked);
      var data = new FormData(form);
      var q = new URLSearchParams(data).toString();
      swap(form.action + (q ? '?' + q : ''));
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = new URLSearchParams(new FormData(form)).toString();
      swap(form.action + (q ? '?' + q : ''));
    });

    /* chips, price bands, clear all and the empty state all carry links */
    scope.addEventListener('click', function (e) {
      var next = e.target.closest('[data-rgc-next]');
      if (next) { more(e, next); return; }
      var link = e.target.closest('[data-rgc-link]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      swap(link.href);
    });
  }

  window.addEventListener('popstate', function () { swap(window.location.href, false); });

  function boot() {
    var scope = root();
    if (!scope) return;
    bind(scope);
    drawer(scope);
    dropdowns(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
